import { render, staticRenderFns } from "./NavigationRecents.vue?vue&type=template&id=32a690b1"
import script from "./NavigationRecents.vue?vue&type=script&lang=js"
export * from "./NavigationRecents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports